module.exports = __webpack_public_path__ + "images/emoji/bicyclist.d2586130922aa1753b30.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bicyclist.png
// module id = 8SUj
// module chunks = 2